import { useNavigate } from "react-router-dom";
import "./login.css";
import { Card, Button, Form, Input, message, Space } from "antd";
import { encryptMD5UpperCase } from "@/utils/EncryptUtil";
import EnumSelect from "@/components/EnumSelect/EnumSelect";
import { register, getCaptchaUrl } from "@/api/system/user";
import { useEffect, useState } from "react";
const Register = () => {
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();

  const [captchaImg, setCaptchaImg] = useState("")

  useEffect(() => {
    getCaptchaImgUrl()
  }, [])

  const getCaptchaImgUrl = async () => {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', getCaptchaUrl, true);
    xhr.responseType = 'blob';
    xhr.onload = function () {
      if (this.status === 200) {
        const blob = new Blob([this.response], { type: "image/jpeg" });
        let url = window.URL.createObjectURL(blob);
        setCaptchaImg(preUrl => url)
      }
    };
    xhr.send();
  }

  const onFinish = async (values) => {
    try {
      // MD5加密
      values.password = encryptMD5UpperCase(values.password);
      const res = await register(values);
      if (res.code === "0") {
        messageApi.success("注册成功")
        navigate("/login")
      } else {
        getCaptchaImgUrl()
        messageApi.error(res?.message || "注册失败")
      }
    } catch (err) {
      console.log(err)
    }
  };
  const onFinishFailed = errorInfo => {
  };
  return (
    <div className="login-page" >
      {contextHolder}
      <Card
        title={
          <div style={{ padding: "8px" }}>
            <div className="login-title">注册</div>
            <a style={{ float: "right" }} onClick={() => {
              navigate("/login")
            }}>前往登录</a>
          </div>
        }
        variant="borderless"
        className="login-container"
      >
        <Form
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          labelAlign="right"
          labelCol={{ span: 5 }}
        >
          <Form.Item label="用户名" name="username" rules={[{ required: true, message: "请输入用户名!", },]} >
            <Input placeholder="请输入用户名" allowClear />
          </Form.Item>
          <Form.Item label="密码" name="password" rules={[{ required: true, message: "请输入密码!", },]} >
            <Input.Password placeholder="请输入密码" allowClear />
          </Form.Item>
          <Form.Item label="真实姓名" name="realName" rules={[{ required: true, message: "请输入真实姓名!", },]} >
            <Input placeholder="请输入真实姓名" allowClear />
          </Form.Item>
          <Form.Item label="手机号" name="tel" >
            <Input placeholder="请输入手机号" allowClear />
          </Form.Item>
          <Form.Item label="邮箱" name="email" >
            <Input placeholder="请输入邮箱" allowClear />
          </Form.Item>
          <Form.Item label="验证码" name="captcha" rules={[{ required: true, message: "请输入验证码!", }]} >
            <div style={{ display: "flex" }}>
              <Space>
                <Input placeholder="请输入验证码" allowClear />
                <img src={captchaImg} style={{ cursor: 'pointer' }} onClick={() => { getCaptchaImgUrl() }} />
              </Space>
            </div>
          </Form.Item>
          <Form.Item label={null} >
            <Button type="primary" htmlType="Submit" className="login-submit">
              注册
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};
export default Register;
